'use client';
import styled from 'styled-components';
import { colors, breakPoints } from '@/styles';

export const ImageFileView = styled.div<{ $proportion?: number }>`
  border: 1px solid ${colors.secondary.lightGray2};
  padding: 10px;
  /* width: 500px; */
  width: 100%;
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${colors.secondary.lightGray1};
  /* opacity: 0.2; */
  background-image:
    repeating-linear-gradient(
      45deg,
      ${colors.secondary.lightGray2} 25%,
      transparent 25%,
      transparent 75%,
      ${colors.secondary.lightGray2} 75%,
      ${colors.secondary.lightGray2}
    ),
    repeating-linear-gradient(
      45deg,
      ${colors.secondary.lightGray2} 25%,
      ${colors.secondary.lightGray1} 25%,
      ${colors.secondary.lightGray1} 75%,
      ${colors.secondary.lightGray2} 75%,
      ${colors.secondary.lightGray2}
    );
  background-position:
    0 0,
    10px 10px;
  background-size: 20px 20px;
  img {
    max-width: ${(props) => props.$proportion || 100}%;
    max-height: ${(props) => props.$proportion || 100}%;
    object-fit: contain;
    /* object-position: left top; */
  }

  @media (max-width: ${breakPoints.mobile}) {
    width: 100%;
    height: calc(100vw - 40px);
  }
`;
